import { ChangeDetectorRef, Component, EventEmitter, Injector, Input, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { DuplicateMinusOrComma } from 'src/app/product-capture/utils/duplicate-minus-or-comma';
import { LeadingZeros } from 'src/app/product-capture/utils/leading-zeros';
import { ControlValueAccessorConnector } from '../controlvalue-accessor.connector';

@Component({
  selector: 'app-dc-input-numeric',
  templateUrl: './dc-input-numeric.component.html',
  styleUrls: ['./dc-input-numeric.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: DcInputNumericComponent,
      multi: true,
    },
  ],
})
export class DcInputNumericComponent extends ControlValueAccessorConnector {
  @Input() placeholder: string;
  @Input() label: string;
  @Input() id: string;
  @Input() helpText?: string;
  @Input() field: any;
  @Input() showTicksIfValid: boolean; // off by default
  @Input() customErrorMessage: string;
  @Input() loading: boolean;
  @Input() maxLength: number;
  @Input() darkMode?: boolean;

  @Output() onChange = new EventEmitter<string>();

  constructor(injector: Injector, private cd: ChangeDetectorRef) {
    super(injector);
  }

  ngAfterContentChecked(): void {
    this.cd.detectChanges();
  }

  getValidationStatus(): string {
    return this.control.invalid
      ? 'invalid'
      : this.showTicksIfValid
      ? 'valid'
      : '';
  }

  onInputChange(newValue: string) {
    let formattedValue = newValue
      .replace(/,/g, '') // removes ','
      .replace(/(?!^-)-/g, '') // removes '-' unless used once to denote negative number
      .replace(/(?<!\d)\.|(?<=\..*?)\./g, '') // removes '.' if there is no number before it, or a decimal already exists
      .replace(/k/gi, '000') // converts k or K > 000
      .replace(/m/gi, '000000'); // converts m or M > 000000

    this.control.setValue(formattedValue, { emitEvent: true });

    this.onChange.emit(formattedValue);
  }

  onKeyDown(event: KeyboardEvent): void {
    const allowedKeys = [
      '-',
      '0',
      '1',
      '2',
      '3',
      '4',
      '5',
      '6',
      '7',
      '8',
      '9',
      '.',
      'k',
      'K',
      'm',
      'M',
      'Backspace',
      'Delete',
      'ArrowLeft',
      'ArrowRight',
      'ArrowUp',
      'ArrowDown',
      'Tab',
    ];

    const inputElement = event.target as HTMLInputElement;
    const valuePriorToThisKeyPress = inputElement.value;

    if (
      !allowedKeys.includes(event.key) ||
      DuplicateMinusOrComma(event.key, valuePriorToThisKeyPress) ||
      LeadingZeros(event.key, valuePriorToThisKeyPress)
    ) {
      event.preventDefault();
      event.stopPropagation();
    }
  }

  writeValue(obj: any): void {
    if (typeof obj === 'number') {
      obj = String(obj);
      this.control.setValue(obj, { emitEvent: false });
    }

    super.writeValue(obj);
  }
}
